<template>
    <div class="card frontdesk-card position-relative">
        <div class="bg-blue-light p-1">
            <TitleButton
                :showBtn="false"
                :showAddNew="false"
                title="Front Desk"
            />
        </div>

        <div class="d-flex flex-wrap gap-1 px-2 mt-2">
            <button
                v-for="tab in tabs"
                :key="tab.value"
                class="btn btn-sm"
                :class="activeTab === tab.value ? 'btn-primary' : 'btn-outline-secondary'"
                @click="onClickTab(tab.value)"
            >
                {{ tab.label }}
            </button>
        </div>

        <div class="px-2 mt-3 mb-4">
            <RunningGuest
                v-if="activeTab === 'running_guest'"
                :isRunningGuest="true"
            />
            <PendingCheckout v-if="activeTab === 'pending_checkout'"/>
            <PreBooked v-if="activeTab === 'pre_booked'"/>
        </div>
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import RunningGuest from '@/components/molecule/company/hotel/hotel-frontdesk/RunningGuest.vue';
import PendingCheckout from '@/components/molecule/company/hotel/hotel-frontdesk/PendingCheckout.vue';
import PreBooked from '@/components/molecule/company/hotel/hotel-frontdesk/PreBooked.vue';
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const $route = useRoute();
const $router = useRouter();

const activeTab = ref('running_guest');
const tabs = ref([
    { label: 'Running Guest', value: 'running_guest' },
    { label: 'Pending Checkout', value: 'pending_checkout' },
    { label: 'Pre Booked', value: 'pre_booked' },
]);

const onClickTab = (value) => {
    if (activeTab.value === value) return;
    activeTab.value = value;
    const routeQuery = Object.assign({}, $route.query, { tab: value });
    delete routeQuery.page;
    $router.replace({ path: $route.path, query: routeQuery });
};

const restoreActiveTab = () => {
    const currentTab = $route.query.tab;
    if (!currentTab) return;
    const matched = tabs.value.find(tab => tab.value === currentTab);
    if (!matched) return;
    activeTab.value = currentTab;
};

onMounted(() => {
    restoreActiveTab();
});
</script>

<style scoped>
.frontdesk-card {
    min-height: 75vh;
    padding-bottom: 4rem;
}
</style>
